import { getLatestLoanApplicationData } from '~/api/loan';

export default {
  methods: {
    /**
     * Check user's bayar tempo state
     * @command - [apicall] checkBayarTempoReapplyDate [/apicall]
     */
    async checkBayarTempoReapplyDate() {
      const responses = {
        bayarTempoReapplyDateIsEligible: '[apiresponse] bayarTempoReapplyIsEligible [/apiresponse]',
        bayarTempoReapplyDateIsNotEligible: '[apiresponse] bayarTempoReapplyIsNotEligible [/apiresponse]',
        bayarTempoCannotBeApplied: '[apiresponse] bayarTempoCannotBeReapplied [/apiresponse]',
        checkBayarTempoReapplyDateError: '[apiresponse] checkBayarTempoReapplyDateError [/apiresponse]',
      };

      try {
        const { data: loanApplicationData } = await getLatestLoanApplicationData(this.$axios, {
          productType: 'bayar-tempo',
        });
        const { reapply_after: reapplyAfter } = loanApplicationData;

        if (!reapplyAfter) {
          this.$zopim.sendChatMsg(responses.bayarTempoCannotBeApplied);
          return;
        }

        const nowTime = new Date().getTime();
        const reapplyTime = new Date(reapplyAfter).getTime();

        if (reapplyTime > nowTime) {
          this.$zopim.sendChatMsg(responses.bayarTempoReapplyDateIsNotEligible);
          return;
        }
        this.$zopim.sendChatMsg(responses.bayarTempoReapplyDateIsEligible);
      } catch (error) {
        this.$zopim.sendChatMsg(responses.checkBayarTempoReapplyDateError);
        console.error('[ERROR] Something is wrong when trying to check user bayar tempo reapply date', error);
      }
    },
  },
};
